export default {
  forgotPassword: {
    title: 'パスワードをお忘れの方',
    email: 'メールアドレス',
    validate: '確定',
    success: 'パスワード変更用のメールをお送りします。',
    new_password: '新しいパスワード',
    validate_password: 'パスワードを確定',
    password_must_match: 'パスワードが一致しません',
    password_changed: 'パスワードが変更されました。',
    send: '送信',
    validate_password_rules: '（英数字8文字以上、大文字を1文字以上含む）',
  },
};
